import React, { Component } from "react";
import ButtonArray from "./ButtonArray";
import Button from "react-bootstrap/lib/Button"
import ArenaView from "./ArenaView";

export default class AdminPanel extends Component {
  render() {
    return (
      <div className="container">
        <h1>Admin Panel</h1>
        <Button onClick={() => this.props.history.push('/admin')}>Buttons</Button>
        <Button onClick={() => this.props.history.push('/arena')}>Arena View</Button>
        <br />
        <ButtonArray
          data={Array.from({ length: 40 }, (v, k) => k + 1)}
          io="25"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminPanel.jsx